module.exports = __webpack_public_path__ + "static/media/imagem-food-pequena-mobile.7767294d.jpg";